import React from 'react'
import BoatsPage from './BoatsPage'

export default function MotorboatsPage() {
  return <BoatsPage categoryFilter="Motorbåd" titleOverride="Motorbåde til salg" />
}
